import { Link } from 'react-router-dom';
import { categories } from '@/mocks/products';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            精选黄油品类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            涵盖发酵黄油、无盐黄油、动物黄油等多品类，满足您的不同需求
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/categories?tab=${cat.id}`}
              className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-full bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors duration-300">
                <span className="w-7 h-7 md:w-8 md:h-8 flex items-center justify-center text-primary-600">
                  <i className={`${cat.icon} text-2xl`}></i>
                </span>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1.5 whitespace-nowrap font-heading">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 text-center line-clamp-2 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}